export default function MySQL_PRIMARYKEY() {
  return (
    <div>
      <h2>MySQL_PRIMARYKEY</h2>    </div>
  );
}